import React, {useEffect, useMemo, useState} from "react";
import {CodeSpecNum, ContentCategory} from "../../../../constant/CodeSpecNum";
import Search from "../../../../components/search/Search";
import {handleActiveError, handleActiveToast} from "../../../../components/sonner/ToastBasic";
import {removeWorks} from "../../../../api/maintenance/WorkService";
import {WORK_LIST_HEADER} from "../../../../components/table/header/Headers";
import {SearchComboBox} from "../../../../components/select/SearchComboBox";
import {slaUsage} from "../../inspection/subPages/InspectionListType";
import {SearchProgressComboBox} from "../../../../components/select/SearchProgressComboBox";
import SearchSection from "../../../../components/search/SearchSection";
import Selector from "../../../../components/selector/Selector";
import {searchWithChildren} from "../../../../components/commonmethod/simmsDrawerMethod";
import {getIndividualSetting, resetIndividualSetting, setIndividualSetting} from "../../../../api/user/UserAccountService";
import {extractObject, initHeaderOrders, nonObject, simmsColumnsToJsGridHeaders} from "../../../../components/commonmethod/CommonMethod";
import {rejected} from "../../../serviceRequest/serviceRequest/subpage/ServiceRequestListType";
import {ToolbarDataTransfer} from "@bavuchoko/js-grid";
import SimmsJsGrid from "../../../../components/js-grid/SimmsJsGrid";
import {navigateWithChildTab, pickDetailTabTitle} from "../../../../components/pageTabs/pageTabsStorage";
import {useNavigate} from "react-router-dom";
import {useExcelDownloadClick} from "../../../../components/commonmethod/excelMethod";
import JsGridExcelGridOpenButton from "../../../../components/js-grid/JsGridExcelGridOpenButton";

function WorkListType({checked, data, date, dataHook, pageInfo}) {
    const navigate = useNavigate();
    const {handleSearch, handlePageSizeChange, saveConditions, refresh, handleGridPageChange} = dataHook;
    const handleDownloadClick = useExcelDownloadClick(saveConditions);

    const [header, setHeader] = useState({order: WORK_LIST_HEADER, exclude: []});
    const searchDate = {startDate: saveConditions.startDate ?? date.startDate, endDate: saveConditions.endDate ?? date.endDate};

    useEffect(() => {
        getIndividualSetting().then((r) => {
            initHeaderOrders(r, WORK_LIST_HEADER, setHeader, [], () => {}, () => {}, 'work');
        });
    }, []);

    const handleRowClick = (row) => {
        const id = row?.id;
        if (id == null) return;
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(row, "작업 상세"),
            url: `/maintenance/work/${id}`,
        });
    };

    const deleteWork = async (rows) => {
        if (!rows?.length) {
            handleActiveToast({message: "삭제할 작업을 선택해주세요."});
            return;
        }
        if (!window.confirm("삭제하시겠습니까?")) {
            return;
        }
        const ids = rows.map((row) => row.id).filter((id) => id != null);
        await removeWorks({ids}).then((response) => {
            if (response.status === 200) {
                handleActiveToast({message: "데이터가 삭제되었습니다"});
            } else if (response.status === 201) {
                handleActiveError({message: response.data.title, description: response.data.reason});
            } else if (response.status === 403) {
                handleActiveError({message: "권한이 없습니다."});
            } else {
                handleActiveError({message: "알 수 없는 에러 발생."});
            }
        });
        checked?.setChecked?.([]);
        refresh();
    };

    const workJsGridHeader = useMemo(() => simmsColumnsToJsGridHeaders(header), [header]);
    const excelGridSearch = useMemo(() => extractObject(saveConditions), [saveConditions]);

    return (
        <div className="container-height">
            <Search refresh={refresh} entity={'work'} searchConditions={saveConditions} handleSearch={handleSearch} handlePageSizeChange={handlePageSizeChange} pageInfo={pageInfo} size detail date={searchDate} searchBar={{placeHolder: '작업제목'}}>
                <SearchSection>
                    <Selector showLabel onChange={(value) => searchWithChildren(handleSearch, 'group', extractObject(saveConditions), value)}
                                 data={saveConditions.group}
                                 parentKey={CodeSpecNum.AssetGroupCode} recursive
                                 entity={"code"} title={"자산그룹"} />
                    <Selector showLabel onChange={(value) => searchWithChildren(handleSearch, 'task', extractObject(saveConditions), value)}
                                 data={saveConditions.task}
                                 parentKey={CodeSpecNum.TaskGroupCode} recursive
                                 entity={"code"} title={"업무그룹"} />
                    <Selector showLabel onChange={(value) => searchWithChildren(handleSearch, 'work', extractObject(saveConditions), value)}
                                 data={saveConditions.work}
                                 parentKey={CodeSpecNum.WorkRequestCode} recursive
                                 entity={"code"} title={"작업코드"} />
                    <SearchComboBox title={"SLA 사용여부"} code={slaUsage} target={"slaUsage"} value={saveConditions}
                                    onChange={(v) => nonObject(saveConditions, v, handleSearch, "slaUsage")}
                    />
                    <SearchProgressComboBox target={"progressNumericValue"} tableName={ContentCategory.WORK} value={saveConditions}
                                            onChange={(v) => nonObject(saveConditions, v, handleSearch, "progressNumericValue")}
                    />
                    <SearchComboBox title={"반려 여부"} code={rejected} target={"rejected"} value={saveConditions}
                                    onChange={(v) => nonObject(saveConditions, v, handleSearch, "rejected")}
                    />
                </SearchSection>
            </Search>

            <div className="container-height-body">
                <SimmsJsGrid
                    loading={dataHook.loading}
                    resizable={true}
                    data={data}
                    theme={'linear'}
                    style={{minHeight: 0, height: '100%'}}
                    header={workJsGridHeader}
                    onHeaderSave={(v) => setIndividualSetting({headers: {work: v}})}
                    onHeaderReset={() => resetIndividualSetting('headers', 'work')}
                    enableRowSelection={true}
                    onRowClick={handleRowClick}
                    onPageChange={handleGridPageChange}
                    toolbarEnd={() => (
                        <div className="flex items-center gap-2">
                            <JsGridExcelGridOpenButton entityName="Work" search={excelGridSearch} />
                            <ToolbarDataTransfer
                                hint="선택 항목 삭제"
                                busyHint="삭제 중…"
                                overlayLabel="삭제 중…"
                                onTransfer={deleteWork}
                            >
                                {(ctx) => (
                                    <button
                                        type="button"
                                        className="text-[13px] px-3 py-0.5 text-black rounded-4 border disabled:cursor-not-allowed"
                                        onClick={() => {
                                            if (ctx.selectedCount === 0) {
                                                handleActiveToast({message: "삭제할 작업을 선택해주세요."});
                                                return;
                                            }
                                            void ctx.transferSelected();
                                        }}
                                    >
                                        삭제
                                    </button>
                                )}
                            </ToolbarDataTransfer>
                            <button
                                type="button"
                                className="text-[13px] px-3 py-0.5 border text-white bg-themeDark rounded-4"
                                onClick={() => navigate('/maintenance/work/create')}
                            >
                                등록
                            </button>
                        </div>
                    )}
                />
            </div>
        </div>
    );
}

export {WorkListType};
